import axios from 'axios';
import { toLocalizedUrl } from 'tradera-utils/url';

const timeDiffInMs = start => {
    return Date.now() - start;
};

const queryServerTime = async (retryCount, preferredLanguageCode) => {
    const latencyLimit = 2000;
    const maxRetries = 2;
    const requestStart = Date.now();
    const {
        data: { currentTime }
    } = await axios.get(
        toLocalizedUrl(
            '/api/webapi/discover/server-time',
            preferredLanguageCode
        )
    );
    const latency = timeDiffInMs(requestStart);

    if (latency < latencyLimit) {
        return { currentTime: Date.parse(currentTime), latency };
    } else if (retryCount < maxRetries) {
        return queryServerTime(retryCount + 1, preferredLanguageCode);
    } else {
        return null;
    }
};

/**
 * Requests server time and returns
 * { currentTime, latency }
 */
export const getServerTime = async preferredLanguageCode => {
    return await queryServerTime(0, preferredLanguageCode);
};
